import { environmentNames } from "./static/environmentNames";
import { environmentsMap } from "./static/environmentsMap";

export default class Environments {
  constructor() {
    const env = environmentsMap[window.location.host];

    const DEFAULT_VALUES = {
      AUTHORITY: "https://accounts-cdt.maersk.com/thirdparty-cdt",
      CLIENT_ID: "thirdparty",
      LOGOUT_URI: "https://accounts-cdt.maersk.com/thirdparty-cdt/auth/logout",
      REDIRECT_PATH: "login-callback",
      BASE_URI: window.location.origin,
      ORIGINAL_URL_PARAM_NAME: "mercplusOriginalURI",
    };

    let OVERRIDES = {};
    switch (env) {
      case environmentNames.DEV:
        OVERRIDES = {
          COOKIE_ID_TOKEN_STORE_NAME: "iam.thirdparty-cdt.mercplus-dev-auth",
          COOKIE_ACCESS_TOKEN_STORE_NAME: "iam.thirdparty-cdt.mercplus-dev-access-token",
          COOKIE_REFRESH_TOKEN_STORE_NAME: "iam.thirdparty-cdt.mercplus-dev-refresh-token",
          COOKIE_EXPIRY_DATE_STORE_NAME: "iam.thirdparty-cdt.mercplus-dev-expiry-date",
        };
        break;
      case environmentNames.TEST:
        OVERRIDES = {
          COOKIE_ID_TOKEN_STORE_NAME: "iam.thirdparty-cdt.mercplus-cdt-auth",
          COOKIE_ACCESS_TOKEN_STORE_NAME: "iam.thirdparty-cdt.mercplus-cdt-access-token",
          COOKIE_REFRESH_TOKEN_STORE_NAME: "iam.thirdparty-cdt.mercplus-cdt-refresh-token",
          COOKIE_EXPIRY_DATE_STORE_NAME: "iam.thirdparty-cdt.mercplus-cdt-expiry-date",
        };
        break;
      case environmentNames.PREPROD:
        OVERRIDES = {
          AUTHORITY: "https://accounts-stage.maersk.com/thirdparty-stage",
          LOGOUT_URI: "https://accounts-stage.maersk.com/thirdparty-stage/auth/logout",
          COOKIE_ID_TOKEN_STORE_NAME: "iam.thirdparty-stage.mercplus-stage-auth",
          COOKIE_ACCESS_TOKEN_STORE_NAME: "iam.thirdparty-stage.mercplus-stage-access-token",
          COOKIE_REFRESH_TOKEN_STORE_NAME: "iam.thirdparty-stage.mercplus-stage-refresh-token",
          COOKIE_EXPIRY_DATE_STORE_NAME: "iam.thirdparty-stage.mercplus-stage-expiry-date",
        };
        break;
      case environmentNames.PROD:
        OVERRIDES = {
          AUTHORITY: "https://accounts.maersk.com/thirdparty",
          LOGOUT_URI: "https://accounts.maersk.com/thirdparty/auth/logout",
          COOKIE_ID_TOKEN_STORE_NAME: "iam.thirdparty.mercplus-auth",
          COOKIE_ACCESS_TOKEN_STORE_NAME: "iam.thirdparty.mercplus-access-token",
          COOKIE_REFRESH_TOKEN_STORE_NAME: "iam.thirdparty.mercplus-refresh-token",
          COOKIE_EXPIRY_DATE_STORE_NAME: "iam.thirdparty.mercplus-expiry-date",
        };
        break;
      default:
        throw new Error(`Unknown Environment ${env}`);
    }
    this.configs = Object.assign(DEFAULT_VALUES, OVERRIDES);
  }
  config(config_name) {
    return this.configs[config_name];
  }
}
